interface SetFaviconColorParams {
	readonly colorOverride: string;
}

export function setFaviconColor({ colorOverride }: SetFaviconColorParams): void {
	try {
		const faviconLinkElement = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
		if (!faviconLinkElement) {
			throw new Error('Favicon link element not found');
		}

		const { href: faviconUrl } = faviconLinkElement;

		const faviconImage = document.createElement('img');

		const onImageLoaded = (): void => {
			const canvas = document.createElement('canvas');
			canvas.width = 48;
			canvas.height = 48;

			const context = canvas.getContext('2d');

			if (!context) {
				throw new Error('Failed to get canvas context');
			}

			context.drawImage(faviconImage, 0, 0);
			context.globalCompositeOperation = 'source-in';

			context.fillStyle = colorOverride;

			context.fillRect(0, 0, 48, 48);
			context.fill();
			faviconLinkElement.type = 'image/x-icon';
			faviconLinkElement.href = canvas.toDataURL();
		};

		faviconImage.addEventListener('load', onImageLoaded);
		faviconImage.src = faviconUrl;
	} catch (error: unknown) {
		console.warn('Changing favicon color failed', error);
	}
}
